import axios from '@/plugins/axios'

export default {
     
    list(params = {}) {
       return axios.httpApi.get('/deal-segment',params);
    }
}